import { SecureRoute } from '@okta/okta-react';
import React, { FC } from 'react';
import { useRouteMatch, Switch } from 'react-router';
import {
  Dashboard,
  lastVisitedDashboardActions,
} from 'components/organisms/dashboard';
import { RoutePaths } from 'constant';
import { AddWidgetPage, EditWidgetPage } from './widgets';

export const DashboardById: FC = () => {
  const match = useRouteMatch(RoutePaths.dashboardById);

  const { dashboardId } = match?.params as { dashboardId: number };

  lastVisitedDashboardActions.update(dashboardId);

  return (
    <>
      <Dashboard dashboardId={dashboardId} />
      <Switch>
        <SecureRoute path={RoutePaths.newWidget}>
          <AddWidgetPage />
        </SecureRoute>
        <SecureRoute path={RoutePaths.editWidget}>
          <EditWidgetPage />
        </SecureRoute>
      </Switch>
    </>
  );
};
